<template>
  <!-- <div class="base_box" @click.prevent="$refs.moreinfoRef.hide()"> -->

  <div class="base_box">
    <AllInfo ref="moreinfoRef" :info="clickInfo"> </AllInfo>
    <EditInfo ref="editinfoRef" @reback="editReback" :info="clickInfo"> </EditInfo>
    <div class="layout_box">
      <div class="left_box">
        <div class="user_box  animated zoomIn roll">
          <div class="user_info card">
            <div class="user_photo">
              <img src="@/assets/img/logo.png" alt="">
            </div>
            <div class="user_data">
              <div class="user_name"> {{user.userAccount}}</div>
              <div class="user_emil"> {{user.email}}</div>
            </div>
          </div>
          <div class="btn_box">
            <div class="btn_card card" :class="item.className" @click="cardFun(item.value,i)" v-for="(item,i) in cardInfo" :key="i">
              <div class="btn_title">{{item.title}}</div>
              <div class="btn_num">{{item.num}}</div>
            </div>

            <div class="btn_card card" @click="$router.push('/upload')">
              <!-- 上传庙宇 -->
              <div class="btn_title">{{$t("user.upload")}}：</div>
              <div class="btn_num"><i class="el-icon-upload"></i></div>
            </div>
          </div>
        </div>
        <div class="table_box  animated slideInUp">
          <el-table class="roll" highlight-current-row height="calc(100vh - 22rem)" :data="templeDate" @row-click="clickRow" stripe border style="width: 100%">
            <!-- <el-table-column prop="id" label="ID" width="80">
            </el-table-column>   -->
            <el-table-column prop="id" label="ID" width="80">
              <template slot-scope="scope">
                {{ scope.$index+1 }}
              </template>
            </el-table-column>
            <!-- 庙名 -->
            <el-table-column prop="name" :label='$t("user.name")' width="180">
            </el-table-column>
            <!-- 修建年代 -->
            <el-table-column prop="years" :label='$t("user.year")' width="80">
              <template slot-scope="scope">
                <!-- 暂不详 -->
                {{ scope.row.years? scope.row.years: '$t("user.unknown")'}}
              </template>
            </el-table-column>
            <!-- 地址 -->
            <el-table-column prop="address" :label='$t("user.address")'>
            </el-table-column>
            <!-- 父庙 -->
            <el-table-column prop="father_id" :label='$t("user.father")' width="180">
            </el-table-column>
            <!-- 操作 -->
            <el-table-column fixed="right" :label='$t("user.operate")' width="120">
              <template slot-scope="scope">
                <!-- 查看 -->
                <el-button type="text" size="small" @click.stop="getInfo(scope.row)">
                  {{$t("user.check")}}
                </el-button>
                <!-- 编辑 -->
                <el-button v-show="clickCard == 3" type="text" size="small" @click="editInfo(scope.row)">
                  {{$t("user.edit")}}
                </el-button>
                <!-- 删除 -->
                <el-button v-show="clickCard == 3" type="text" size="small" @click="delInfo(scope.row)">
                  {{$t("user.delete")}}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="list_box">

            <div class="page_box card">
              <el-pagination @size-change="pageSizeChange" @current-change="pageChange" :pager-count="5" :current-page="pageItem.page" :page-sizes="[25, 50, 100, 200]" :page-size="pageItem.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="templeNum">
              </el-pagination>
            </div>

            <div class="page_box_mobile  card animated slideInUp roll">
              <el-pagination small @size-change="pageSizeChange" @current-change="pageChange" :pager-count="5" :current-page="pageItem.page" :page-sizes="[25, 50, 100, 200]" :page-size="pageItem.pageSize" layout="sizes, prev, pager, next" :total="templeNum">
              </el-pagination>
            </div>
          </div>
        </div>

      </div>
      <div class="right_box">
        <div class="info_box">
          <CardInfo :info="clickInfo"> </CardInfo>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CardInfo from "../../components/CardInfo.vue";
import AllInfo from "../../components/AllInfo.vue";
import EditInfo from "../../components/EditInfo.vue";
export default {
  components: {
    CardInfo,
    AllInfo,
    EditInfo,
  },
  name: "user",

  data() {
    return {
      user: null,
      templeDate: null,
      templeNum: 0,
      clickInfo: {}, //当前点击的庙宇信息
      pageItem: {
        page: 1,
        pageSize: 100,
        name: "",
        state: "1",
        operator: "",
      },
      cardInfo: [
        {
          title: this.$t("user.passnum"),
          num: 0,
          value: 1,
          className: "",
        },
        {
          title: this.$t("user.checknum"),
          num: 0,
          value: 2,
          className: "",
        },
        {
          title: this.$t("user.nopassnum"),
          num: 0,
          value: 3,
          className: "",
        },
      ],
      clickCard: 0,
    };
  },
  computed: {},
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.getTempleList();
  },
  mounted() {},
  methods: {
    // 切换页数
    pageSizeChange(num) {
      this.pageItem.pageSize = num;
      this.getTempleList();
    },
    //切换每页数量
    pageChange(num) {
      this.pageItem.page = num;
      this.getTempleList();
    },
    //获取分页庙宇列表
    getTempleList(value) {
      let that = this;
      let pardata = {
        state: value ? value : "",
        page: this.pageItem.page,
        pageSize: this.pageItem.pageSize,
        // name: this.pageItem.name,
        operator: this.user.userAccount,
      };
      this.$Loading.show();
      this.http.post("temple/getCheckTempleListPage", pardata).then((res) => {
        this.$Loading.hide();
        if (res.code == "0") {
          if (!value) {
            for (let i = 0; i < res.data.totalCount.length; i++) {
              switch (res.data.totalCount[i].groupId) {
                case "1":
                  that.cardInfo[0].num = res.data.totalCount[i].value;
                  break;
                case "2":
                  that.cardInfo[1].num = res.data.totalCount[i].value;
                  break;
                case "3":
                  that.cardInfo[2].num = res.data.totalCount[i].value;
                  break;
              }
            }
          } else {
            this.templeDate = res.data.templeList.records;
            this.templeNum = res.data.templeList.total;
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },

    clickRow(row, event, column) {
      this.clickInfo = row;
    },
    getInfo(row) {
      this.clickInfo = row;
      this.$refs.moreinfoRef.show();
    },
    cardFun(value, index) {
      this.clickCard = value;
      for (let i = 0; i < this.cardInfo.length; i++) {
        this.cardInfo[i].className = "";
      }
      this.cardInfo[index].className = "clickCard";
      // 0: 已删除  1：审核通过   2：待审核  3： 审核未通过
      //调用两次接口，一次是获取庙宇审核等数量，一次是获取当前状态的庙宇
      this.getTempleList("");
      this.getTempleList(value);
    },

    editInfo(row) {
      this.clickInfo = row;
      this.$refs.editinfoRef.show();
    },
    editReback(flag) {
      if (flag) {
        //调用两次接口，一次是获取庙宇审核等数量，一次是获取当前状态的庙宇
        this.getTempleList("");
        this.getTempleList(this.clickCard);
      }
    },
    // 删除
    delInfo(row) {
      this.$confirm(
        // 该操作将彻底删除该庙宇，是否确认删除
        this.$t("user.t1") + "“" + row.name + "”？",
        this.$t("common.delete"),
        {
          confirmButtonText: this.$t("common.sure"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          let parData = {
            id: row.id,
            // state: "0",
          };
          this.http.post("temple/deleteTempleReally", parData).then((res) => {
            this.$Loading.hide();
            if (res.code == "0") {
              this.$message({
                // 删除庙宇成功
                message: this.$t("user.t2"),
                type: "success",
              });
              this.getTempleList("");
              this.getTempleList(this.clickCard);
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            // 已取消删除
            message: this.$t("user.t3"),
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/_common.scss";

.base_box {
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding-top: $head-height;
  box-sizing: border-box;
  background: url("../../assets/img/banner.jpg") no-repeat fixed center;
  background-size: auto 100%;

  .layout_box {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    .left_box {
      width: 70%;
      height: 100%;
      box-sizing: border-box;
      .user_box {
        border-radius: $r-mid;
        margin: $m-mid;
        margin-right: 0;
        padding: $m-mid;
        background-color: $c-glass;
        backdrop-filter: $d-glass;
        border: $b-glass;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        // flex-wrap: wrap;
        overflow: hidden;
        overflow-x: auto;
        .user_info {
          display: flex;
          height: 9rem;
          box-sizing: border-box;
          align-items: center;
          padding: $m-mid;
          .user_photo {
            width: 6rem;
            height: 6rem;
            border-radius: 50%;
            box-shadow: $shadow;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .user_data {
            margin-left: $m-mid;
            width: 10rem;
            font-size: $f-big;
            color: $c-main;
            overflow: hidden;
            .user_name {
              font-size: $m-big;
              margin: $m-lit 0;
            }
            .user_emil {
              color: $c-text-main;
            }
          }
        }

        .btn_box {
          box-sizing: border-box;
          // display: flex;
          // justify-content: space-around;
          // min-width: 52rem;
          width: 100%;
          display: flex;
          align-items: center;
          .btn_card {
            box-sizing: border-box;
            width: 12rem;
            height: 9rem;
            margin-left: $m-mid;
            padding: $m-mid;
            cursor: pointer;

            .btn_title {
              font-size: $f-mid;
              color: $c-main;
            }
            .btn_num {
              font-family: "syBlack_r", "sySong_r";
              font-weight: 700;
              text-align: center;
              font-size: calc($f-hug * 2);
              color: $c-text-main;
              transition: all 0.3rem;
            }
            &:hover {
              .btn_num {
                margin-top: -$m-min;
                font-size: calc($f-hug * 2.5);
              }
            }
            &:nth-child(1) {
              .btn_num {
                color: $c-success;
              }
            }
            &:nth-child(2) {
              .btn_num {
                color: $c-review;
              }
            }
            &:nth-child(3) {
              .btn_num {
                color: $c-fail;
              }
            }
            &:nth-child(4) {
              .btn_num {
                color: $c-main;
              }
            }
          }
        }
      }
      // 点击样式
      .clickCard {
        border: $b-border;
        // background-color: $c-main-light;
        transform: scale(0.9);
        opacity: 0.9;
      }
      .table_box {
        border-radius: $r-min;
        margin: $m-mid;
        margin-right: 0;
        margin-top: 0;
        padding: $m-mid;
        background-color: $c-glass;
        opacity: 0.95;
        border-radius: $r-mid;
        height: calc(100vh - 18.2rem);
        border: $b-glass;
        overflow: hidden;
        .el-table {
          border-radius: $r-mid;
        }

        .list_box {
          .page_box {
            margin-top: $m-mid;
            padding: $m-lit;
            // color: $c-main;
          }
        }
      }
    }
    .right_box {
      width: 30%;
      height: 100%;
      .info_box {
        height: calc(100vh - 6.2rem);
        margin: $m-mid;
        padding: $m-mid;
        border: $b-glass;
        border-radius: $r-mid;
      }
    }
  }
}

.page_box_mobile {
  display: none;
}

@media screen and (min-width: 451px) and (max-width: 1000px) {
  .base_box {
    .layout_box {
      width: 100%;
      .left_box {
        width: 100%;
        .user_box {
          margin: $m-mid;
          .user_info {
            .user_data {
              width: 8rem;
            }
          }
        }
        .table_box {
          margin: $m-mid;
          height: calc(100vh - 19rem);
        }
      }
      .right_box {
        display: none;
      }
    }
  }
}

@media screen and (max-width: 450px) {
  .base_box {
    .layout_box {
      width: 100%;
      .left_box {
        width: 100%;

        .user_box {
          border-radius: $r-mid;
          margin: $m-lit;
          padding: $m-lit;
          border: $b-glass;
          display: block;
          // align-items: center;
          box-sizing: border-box;
          // flex-wrap: wrap;
          overflow: hidden;
          overflow-x: auto;

          .user_info {
            display: flex;
            height: 5rem;
            width: 100%;
            box-sizing: border-box;
            align-items: center;
            padding: $m-lit;
            margin-bottom: $m-lit;
            .user_photo {
              width: 3.5rem;
              height: 3.5rem;
              border-radius: 50%;
              box-shadow: $shadow;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .user_data {
              margin-left: $m-lit;
              font-size: $f-lit;
              color: $c-main;
              overflow: hidden;
              .user_name {
                font-size: $m-mid;
                margin: $m-lit 0;
              }
              .user_emil {
                color: $c-text-main;
              }
            }
          }

          .btn_box {
            box-sizing: border-box;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-around;
            .btn_card {
              box-sizing: border-box;
              height: 6rem;
              margin: 0 0.1rem;
              padding: $m-lit;
              cursor: pointer;
              .btn_title {
                font-size: 12px;
                color: $c-main;
              }
              .btn_num {
                margin-top: $m-lit;
                font-family: "syBlack_r", "sySong_r";
                font-weight: 700;
                text-align: center;
                font-size: $f-hug;
                color: $c-text-main;
                transition: all 0.3rem;
              }
              &:hover {
                .btn_num {
                  margin-top: 0;
                  font-size: calc($f-hug * 1.2);
                }
              }
              &:nth-child(1) {
                .btn_num {
                  color: $c-success;
                }
              }
              &:nth-child(2) {
                .btn_num {
                  color: $c-review;
                }
              }
              &:nth-child(3) {
                .btn_num {
                  color: $c-fail;
                }
              }
              &:nth-child(4) {
                .btn_num {
                  color: $c-main;
                }
              }
            }
          }
        }
        // 点击样式
        .clickCard {
          border: $b-border;
          // background-color: $c-main-light;
          transform: scale(1);
          opacity: 0.9;
          font-size: calc($f-hug * 1.2);
        }

        .table_box {
          margin: $m-lit;
          padding: $m-lit;
          height: calc(100vh - 18.5rem);
        }
      }
      .right_box {
        display: none;
      }
    }
  }
  .page_box {
    display: none;
  }
  .page_box_mobile {
    display: block;
    width: 100%;
    margin: 0 auto;
    margin-top: $m-lit;
    padding: $m-lit;
    font-size: $f-lit;
  }
}
</style>